import { router } from 'expo-router';
import { Platform, StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { StyleSheet } from 'react-native';

import { IconClose, Text, tokens } from '@fhs/ui';

interface Props {
  title: string;
  onClose?: () => void;
  style?: StyleProp<ViewStyle>;
}

export function ActionSheetScreenHeader({ title, onClose, style }: Props) {
  return (
    <View style={[styles.container, style]}>
      <View
        accessibilityLabel={title}
        accessibilityRole="header"
        accessible
        focusable
        style={styles.titleFocus}
        {...(Platform.OS === 'web'
          ? ({
              tabIndex: 0,
            } as Record<string, unknown>)
          : {})}
      >
        <Text.Ui accessible={false} size="md" weight="semibold">
          {title}
        </Text.Ui>
      </View>
      <TouchableOpacity
        accessibilityLabel={`Close ${title}`}
        accessibilityRole="button"
        style={styles.closeIcon}
        onPress={onClose ?? router.back}
        {...(Platform.OS === 'web'
          ? ({
              'aria-label': `Close ${title}`,
            } as Record<string, unknown>)
          : {})}
      >
        <IconClose
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility="no-hide-descendants"
          size={24}
        />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 18,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: tokens.colors.$black10,
  },
  titleFocus: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    position: 'absolute',
    right: 16,
  },
});
